import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '..'

const ProfileRewards = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      fill="#6826A0"
      stroke="#6826A0"
      strokeWidth={0.5}
      d="M18.672 8.192h-2.48c.268-.42.408-.91.4-1.408a2.592 2.592 0 0 0-4.6-1.6 2.568 2.568 0 0 0-2-.96 2.592 2.592 0 0 0-2.2 3.968h-2.4a1.144 1.144 0 0 0-1.184 1.144v1.312a1.145 1.145 0 0 0 .92 1.12 1.76 1.76 0 0 0-.12.616v5.6A1.793 1.793 0 0 0 6.8 19.776h10.4a1.784 1.784 0 0 0 1.792-1.792v-5.6c0-.21-.038-.42-.112-.616a1.146 1.146 0 0 0 .912-1.12V9.336a1.145 1.145 0 0 0-1.12-1.144Zm-6.08 1.2h6.04v1.2h-6.04v-1a.56.56 0 0 0 0-.2Zm1.44-4a1.4 1.4 0 1 1 0 2.8h-1.44V6.784a1.408 1.408 0 0 1 1.416-1.392h.024Zm-5.44 1.392a1.4 1.4 0 0 1 2.8 0v1.408h-1.384a1.4 1.4 0 0 1-1.416-1.408Zm-3.2 2.608h6.04a.56.56 0 0 0-.04.2v1h-6v-1.2Zm.8 8.592v-5.6a.592.592 0 0 1 .592-.592h4.608v6.8H6.8a.592.592 0 0 1-.608-.608Zm11.6 0a.592.592 0 0 1-.584.592h-4.616v-6.8h4.616a.592.592 0 0 1 .584.592v5.616Z"
    />
  </Svg>
)
export default ProfileRewards
